// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdfContainer {
  margin-top: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
}

.pdfFrame {
  width: 70%;
  height: 90dvh;
}
@media (max-width: 767px) {
  .pdfFrame {
    width: 90%;
  }
  .pdfContainer {
    display: flex;
    align-content: center;
    justify-content: center;

    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Resume.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,uBAAuB;;IAEvB,WAAW;EACb;AACF","sourcesContent":[".pdfContainer {\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  align-content: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.pdfFrame {\r\n  width: 70%;\r\n  height: 90dvh;\r\n}\r\n@media (max-width: 767px) {\r\n  .pdfFrame {\r\n    width: 90%;\r\n  }\r\n  .pdfContainer {\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
